"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgBalanceFilled = function SvgBalanceFilled(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("path", {
    d: 'M2 4c0-1.333.667-2 2-2h16c1.334 0 2 .667 2 2v16c0 1.333-.667 2-2 2H4c-1.333 0-2-.667-2-2V4zm6 12c-.666 0-1 .332-1 .996 0 .665.334 1 1 1.004h2c.667.005 1-.328 1-.997S10.667 16 10 16H8zm6 0c-.667 0-1 .332-1 .996 0 .665.333 1 1 1.004h2c.667.005 1-.328 1-.997S16.667 16 16 16h-2zm-7.79-5.624c.042.427.197.784.464 1.072l1.64 1.87c.17.2.34.365.507.492.168.127.5.19.997.19h4.39c.477 0 .799-.063.967-.19.167-.127.347-.291.538-.492l1.64-1.87c.302-.341.464-.719.486-1.133.032-.62-.255-1.194-.255-1.194C16.378 7.04 14.52 6 12.013 6 9.505 6 7.648 7.04 6.442 9.12c0 0-.296.615-.233 1.256zm1.99-.145C9.125 8.706 10.43 7.963 12.112 8c1.682.038 2.928.781 3.738 2.23L14.426 12h-1.42l.433-1.663c.031-.147.031-.882-.713-1.097-.744-.215-1.162.426-1.213.615L10.936 12H9.745L8.2 10.23z'
  }));
};

exports.default = SvgBalanceFilled;